/**
 * Human formatting for a routine's next/first run instant, in the ROUTINE's
 * timezone (not the viewer's). Client-safe (zero deps — pure Intl); shared by
 * the schedule editor, the wizard review step, and the detail-page chip so the
 * three surfaces can't drift. Best-effort: an unknown timezone string must
 * degrade, never throw mid-render.
 */
export function formatNextRun(iso: string, timezone: string): string {
  try {
    return new Intl.DateTimeFormat(undefined, {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      timeZone: timezone,
    }).format(new Date(iso));
  } catch {
    return new Date(iso).toLocaleString();
  }
}
